exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select2-container--default .select2-selection--multiple {\n  background-color: #eff4fd !important;\n}\n.select2-selection__choice{\n  background-color: #eff4fd !important;\n}\n", ""]);

// exports
